<div class="layout small-gap">
  <div class="section-header no-border layout_one_up_center">
    Welcome, {{ displayName }}
  </div>

  <div class="layout_one_up_center">
    <div class="announcement-content-body">
      <b>Note:</b> The USAN application deadline for the <b>December 2026</b> USAN Council meeting is <b>October 23, 2026</b>. Following review at the USAN Council meeting, most applicants can expect a response from the USAN Council before the deadline for the spring INN consultation.
    </div>
  </div>
  <div class="layout_one_up_center">
    <div class="text-content text-content-body">
      <b>Application Instructions</b>
    </div>
    <span class="text-content text-content-body">
      Welcome to the USAN Application Portal. This platform streamlines the process of applying for United States Adopted Names (USAN) for various pharmaceutical compounds and materials. To begin, review the six available application forms and select the one that best fits your needs. Each form is designed for specific types of substances. If you need assistance or have questions about which form to use, please contact the USAN staff for guidance.
    </span>
  </div>
  <app-create-application></app-create-application>
  <div class="flexbox layout_one_up_center">
    <ng-continer *ngIf="!loadingComplete" class="spinner-div">
      <mat-spinner class="spinner-cls"></mat-spinner>
    </ng-continer>
  </div>
  <div class="flexbox layout_one_up_center">
    <app-draft-applications-list [draftApplications]="draftApplications"></app-draft-applications-list>
  </div><br>
  <div class="flexbox layout_one_up_center">
    <app-submitted-applications-list></app-submitted-applications-list>
  </div>
</div>
